<div class="w-[850px] max-w-[90%] mx-auto">
  <div class="flex flex-col sm:flex-row gap-8 items-start py-8">
    <!-- Image Column - First on mobile, right side on desktop -->
    <div class="w-full sm:w-2/5 flex justify-center order-1 sm:order-2">
      <div class="relative">
        <!-- Money Back Guarantee Seal -->
        <img 
          src="https://cdn.drmartypets.com/images/mbgSeal.png" 
          alt="90 Day Money Back Guarantee Seal" 
          class="w-auto h-auto object-contain"
        >
      </div>
    </div>
    
    <!-- Buttons Column - Second on mobile, left side on desktop -->
    <div class="w-full sm:w-3/5 order-2 sm:order-1">
      <!-- Custom HTML content div -->
      <div class="mb-6" *ngIf="customHtmlContent" [innerHTML]="customHtmlContent"></div>
      
      <div class="space-y-6">

          <button 
            data-qa="cta-yes" 
            class="btn btn-primary btn-accent uppercase"
            [ngClass]="upsellCtaTextButtonsClass"
            (click)="nextPage(true)" 
            data-te="cta-yes" 
            [innerHTML]="buttonYesText">
          </button>

          <button 
            data-qa="cta-no" 
            class="btn btn-gray uppercase"
            [ngClass]="upsellCtaTextButtonsClass"
            (click)="nextPage(false)" 
            [innerHTML]="buttonNoText" 
            data-te="cta-no">
          </button>
          
      </div>
    </div>
  </div>
</div>

